//投票添加
export const SK_VOTE_ADD = 'sk_vote_add'
//投票详情
export const SK_VOTE_DETAIL = 'sk_vote_detail'
//投票选项
export const SK_VOTE_OPTS = 'sk_vote_opts'



// WEBPACK FOOTER //
// ./src/store/give-course/vote/type.js